import React, { useContext, useEffect } from "react";

import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
// import Hyper from "./Theme/Hyper";
import Main from "./components/Views/Main";
import { UIContext, UIProvider } from "./contexts/UIContext";
import Config from "./components/Views/Config";
import { APIProvider } from "./contexts/APIContext";
import Test from "./components/Views/Test";
import { GameEventsProvider } from "./contexts/GameEventContext";
import { UserProvider, UserContext } from "./contexts/UserContext";
import HoldingPage from "./components/Views/HoldingPage";

function getParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

function App() {
  return (
    <Router basename={process.env.PUBLIC_URL}>
      <UserProvider>
        <GameEventsProvider>
          <APIProvider>
            <UIProvider>
              <ShowMain>
                <Switch>
                  <Route path="/">
                    <Main />
                  </Route>
                </Switch>
              </ShowMain>
            </UIProvider>
          </APIProvider>
        </GameEventsProvider>
      </UserProvider>
    </Router>
  );
}
function ShowMain({ children }) {
  const { uiView, setUIView } = useContext(UIContext);
  const showHolding =
    String(
      window.ENV?.REACT_APP_SHOW_HOLDING || process.env.REACT_APP_SHOW_HOLDING,
    ).toLowerCase() === "true";

  if (showHolding) {
    return <HoldingPage />;
  }

  return <div class="container max-w-screen-xl">{children}</div>;
}
export default App;
